"use strict";

import { incentiveConstants } from "../_constants";

// start of about campaign actions

export const incentiveAddAboutCampaignRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_REQUEST,
          payload,
     };
};

export const incentiveAddAboutCampaignComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_COMPLETE,
          payload,
     };
};


export const incentiveAboutContentGetListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_REVISION_CONTENT_LIST_REQUEST,
          payload,
     };
};

export const incentiveAboutContentGetListComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_REVISION_CONTENT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveAboutPublishedRevisionRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_REQUEST,
          payload,
     };
};

export const incentiveAboutPublishedRevisionComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_COMPLETE,
          payload,
     };
};


export const incentiveAboutContentGetRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_CONTENT_GET_REQUEST,
          payload,
     };
};

export const incentiveAboutContentGetComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_CONTENT_GET_COMPLETE,
          payload,
     };
};

export const incentiveAboutContentPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_REQUEST,
          payload,
     };
};

export const incentiveAboutContentPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_COMPLETE,
          payload,
     };
};


// end of about campaign actions

export const incentiveListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TABLE_LIST_REQUEST,
          payload,
     };
};

export const incentiveListComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TABLE_LIST_COMPLETE,
          payload,
     };
};

export const incentiveDeleteRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_DELETE_REQUEST,
          payload,
     };
};

export const incentiveDeleteComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_DELETE_COMPLETE,
          payload,
     };
};

export const incentiveTypesRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TYPES_REQUEST,
          payload,
     };
};

export const incentiveTypesComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TYPES_COMPLETE,
          payload,
     };
};

export const incentiveSearchListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_REQUEST,
          payload,
     };
};

export const incentiveSearchListComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_COMPLETE,
          payload,
     };
};

export const campaignTypesRequest = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_TYPES_REQUEST,
          payload,
     };
};

export const campaignTypesComplete = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_TYPES_COMPLETE,
          payload,
     };
};

export const getCampaignParticipantsRequest = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_PARTICIPANTS_REQUEST,
          payload,
     };
};

export const getCampaignParticipantsComplete = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_PARTICIPANTS_COMPLETE,
          payload,
     };
};

export const getCampaignSalesRequest = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_SALES_REQUEST,
          payload,
     };
};

export const getCampaignSalesComplete = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_SALES_COMPLETE,
          payload,
     };
};

export const getCampaignTemplateTypeRequest = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_TEMPLATE_TYPES_REQUEST,
          payload,
     };
};

export const getCampaignTemplateTypeComplete = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_TEMPLATE_TYPES_COMPLETE,
          payload,
     };
};

export const getCampaignProductRequest = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_PRODUCTS_REQUEST,
          payload,
     };
};

export const getCampaignProductComplete = (payload) => {
     return {
          type: incentiveConstants.GET_CAMPAIGN_PRODUCTS_COMPLETE,
          payload,
     };
};

export const participantListRequest = (payload) => {
     return {
          type: incentiveConstants.GET_PARTICIPANT_LIST_REQUEST,
          payload,
     };
};

export const participantListComplete = (payload) => {
     return {
          type: incentiveConstants.GET_PARTICIPANT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveChangeStatusRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_CHANGE_STATUS_REQUEST,
          payload,
     };
};

export const incentiveChangeStatusComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_CHANGE_STATUS_COMPLETE,
          payload,
     };
};

export const creationStepOneRequest = (payload) => {
     return {
          type: incentiveConstants.CREATION_STEP_ONE_REQUEST,
          payload,
     };
};

export const creationStepOneComplete = (payload) => {
     return {
          type: incentiveConstants.CREATION_STEP_ONE_COMPLETE,
          payload,
     };
};

export const getAboutCampaignStepOneRequest = (payload) => {
     return {
          type: incentiveConstants.GET_ABOUT_CAMPAIGN_STEP_ONE_REQUEST,
          payload,
     };
};

export const getAboutCampaignStepOneComplete = (payload) => {
     return {
          type: incentiveConstants.GET_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE,
          payload,
     };
};

export const updateAboutCampaignStepOneRequest = (payload) => {
     return {
          type: incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_REQUEST,
          payload,
     };
};

export const updateAboutCampaignStepOneComplete = (payload) => {
     return {
          type: incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE,
          payload,
     };
};

export const listCampaignParticipantsRequest = (payload) => {
     return {
          type: incentiveConstants.LIST_CAMPAIGN_PARTICIPANTS_REQUEST,
          payload,
     };
};

export const listCampaignParticipantsComplete = (payload) => {
     return {
          type: incentiveConstants.LIST_CAMPAIGN_PARTICIPANTS_COMPLETE,
          payload,
     };
};

export const addCampaignParticipantsRequest = (payload) => {
     return {
          type: incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_REQUEST,
          payload,
     };
};

export const addCampaignParticipantsComplete = (payload) => {
     return {
          type: incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_COMPLETE,
          payload,
     };
};

export const incentiveHeaderContentAddRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_ADD_REQUEST,
          payload,
     };
};

export const incentiveHeaderContentAddComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_ADD_COMPLETE,
          payload,
     };
};

export const incentiveHeaderContentUpdateRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_EDIT_REQUEST,
          payload,
     };
};

export const incentiveHeaderContentUpdateComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_EDIT_COMPLETE,
          payload,
     };
};

export const incentiveHeaderContentGetListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_LIST_REQUEST,
          payload,
     };
};

export const incentiveHeaderContentGetListComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveHeaderContentGetRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_GET_REQUEST,
          payload,
     };
};

export const incentiveHeaderContentGetComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_GET_COMPLETE,
          payload,
     };
};

export const incentiveHeaderContentPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_REQUEST,
          payload,
     };
};

export const incentiveHeaderContentPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_COMPLETE,
          payload,
     };
};

export const getParticipantDataTemplateRequest = (payload) => {
     return {
          type: incentiveConstants.GET_PARTICIPANT_DATA_TEMPLATE_REQUEST,
          payload,
     };
};

export const getParticipantDataTemplateComplete = (payload) => {
     return {
          type: incentiveConstants.GET_PARTICIPANT_DATA_TEMPLATE_COMPLETE,
          payload,
     };
};

export const getSalseDataTemplateRequest = (payload) => {
     return {
          type: incentiveConstants.GET_SALSE_DATA_TEMPLATE_REQUEST,
          payload,
     };
};

export const getSalseDataTemplateComplete = (payload) => {
     return {
          type: incentiveConstants.GET_SALSE_DATA_TEMPLATE_COMPLETE,
          payload,
     };
};

export const listCampaignAdminsRequest = (payload) => {
     return {
          type: incentiveConstants.LIST_CAMPAIGN_ADMINS_REQUEST,
          payload,
     };
};

export const listCampaignAdminsComplete = (payload) => {
     return {
          type: incentiveConstants.LIST_CAMPAIGN_ADMINS_COMPLETE,
          payload,
     };
};

export const addCampaignAdminsRequest = (payload) => {
     return {
          type: incentiveConstants.ADD_CAMPAIGN_ADMINS_REQUEST,
          payload,
     };
};

export const addCampaignAdminsComplete = (payload) => {
     return {
          type: incentiveConstants.ADD_CAMPAIGN_ADMINS_COMPLETE,
          payload,
     };
};

export const incentiveHeaderPublishedRevisionRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_REQUEST,
          payload,
     };
};

export const incentiveHeaderPublishedRevisionComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_COMPLETE,
          payload,
     };
};

// start of quick section 

export const incentiveQuickContentAddRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_REQUEST,
          payload,
     };
};

export const incentiveQuickContentAddComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_COMPLETE,
          payload,
     };
};


export const incentiveQuickContentUpdateComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_EDIT_COMPLETE,
          payload,
     };
};

export const incentiveQuickContentGetListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_REVISION_CONTENT_LIST_REQUEST,
          payload,
     };
};

export const incentiveQuickContentGetListComplete = (payload) => {
          return {
          type: incentiveConstants.INCENTIVE_QUICK_REVISION_CONTENT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveQuickContentGetRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_GET_REQUEST,
          payload,
     };
};

export const incentiveQuickContentGetComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_GET_COMPLETE,
          payload,
     };
};

export const incentiveQuickContentPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_REQUEST,
          payload,
     };
};

export const incentiveQuickContentPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_COMPLETE,
          payload,
     };
};


export const incentiveQuickPublishedRevisionRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_REQUEST,
          payload,
     };
};

export const incentiveQuickPublishedRevisionComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_COMPLETE,
          payload,
     };
};




// end of quick section


// start of terms and conditions

export const incentiveTermContentAddRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_REQUEST,
          payload,
     };
};

export const incentiveTermContentAddComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_COMPLETE,
          payload,
     };
};

export const incentiveTermContentUpdateRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_EDIT_REQUEST,
          payload,
     };
};

export const incentiveTermContentUpdateComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_EDIT_COMPLETE,
          payload,
     };
};

export const incentiveTermContentGetListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_LIST_REQUEST,
          payload,
     };
};

export const incentiveTermContentGetListComplete = (payload) => {

     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveTermContentGetRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_GET_REQUEST,
          payload,
     };
};

export const incentiveTermContentGetComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_GET_COMPLETE,
          payload,
     };
};

export const incentiveTermContentPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_REQUEST,
          payload,
     };
};

export const incentiveTermContentPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_COMPLETE,
          payload,
     };
};

export const incentiveTermPublishedRevisionRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_REQUEST,
          payload,
     };
};

export const incentiveTermPublishedRevisionComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_COMPLETE,
          payload,
     };
};



// end of terms and conditions


// start of faq

export const incentiveFaqContentAddRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_REQUEST,
          payload,
     };
};

export const incentiveFaqContentAddComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_COMPLETE,
          payload,
     };
};

export const incentiveFaqContentUpdateRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_EDIT_REQUEST,
          payload,
     };
};

export const incentiveFaqContentUpdateComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_EDIT_COMPLETE,
          payload,
     };
};

export const incentiveFaqContentGetListRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_LIST_REQUEST,
          payload,
     };
};

export const incentiveFaqContentGetListComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_LIST_COMPLETE,
          payload,
     };
};

export const incentiveFaqContentGetRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_GET_REQUEST,
          payload,
     };
};

export const incentiveFaqContentGetComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_GET_COMPLETE,
          payload,
     };
};

export const incentiveFaqContentPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_REQUEST,
          payload,
     };
};

export const incentiveFaqContentPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_COMPLETE,
          payload,
     };
};


export const incentiveFaqPublishedRevisionRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_REQUEST,
          payload,
     };
};

export const incentiveFaqPublishedRevisionComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_COMPLETE,
          payload,
     };
};



// end of faq

export const incentiveContentUnPublishRequest = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_REQUEST,
          payload,
     };
};

export const incentiveContentUnPublishComplete = (payload) => {
     return {
          type: incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_COMPLETE,
          payload,
     };
};

